import dayjs from "@/lib/helpers/dayjs";

const SIGNATURE_TIMEZONE = "America/New_York";
const SIGNATURE_TIMESTAMP_FORMAT = "MM/DD/YYYY [·] h:mm A z";

export function formatSignatureTimestamp(timestamp?: Nullable<string>) {
  if (!timestamp || !/(?:Z|[+-]\d{2}:\d{2})$/i.test(timestamp)) return undefined;

  const date = dayjs(timestamp);

  return date.isValid()
    ? date.tz(SIGNATURE_TIMEZONE).format(SIGNATURE_TIMESTAMP_FORMAT)
    : undefined;
}
